import { observer } from 'mobx-react-lite'
import { type JobListViewModel } from '@/features/jobs/details/components/JobList/JobListViewModel'
import { useFeatures } from '@/contexts/root-store-context'
import { JobListEmpty } from '@/features/jobs/details/components/JobList/JobListEmpty'

export interface JobListEmptyContainerProps {
  vm: JobListViewModel
}

export const JobListEmptyContainer = observer(function JobListEmptyContainer({
  vm,
}: JobListEmptyContainerProps) {
  const { shellInfo } = useFeatures(({ shell }) => ({
    shellInfo: shell.shellInfo,
  }))
  return (
    <JobListEmpty
      wasSearching={vm.searcher.lastSearch.filtersApplied}
      canViewOpportunities={vm.canViewOpportunities}
      corporateMode={shellInfo.corporateMode}
    />
  )
})
